/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7984ba5b"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabLanguage/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7984ba5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7984ba5b', __exports__)) {
    api.reload('7984ba5b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7984ba5b", () => {
    api.rerender('7984ba5b', render)
  })

}


export default __exports__